module.exports = __webpack_public_path__ + "static/media/Figure12.489277a7.jpg";